module.exports = __webpack_public_path__ + "static/media/data-science-icon.175d1a9c.svg";